import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-message-detail',
  templateUrl: './message-detail.component.html',
  styleUrls: ['./message-detail.component.scss']
})
export class MessageDetailComponent implements OnInit {
  displayedColumns: string[] = ['origin', 'message'];
  
  /**
   * Update version by web
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit() { }
}
